import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactPage = () => {
  const formRef = useRef(null);
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ycc2bvx",      // Your EmailJS service ID
        "template_a3jem2f",     // Your EmailJS template ID
        formRef.current,
        "AIO6wYVOOFNn0o1uT"     // Your public key
      )
      .then(
        (result) => {
          setStatusMessage("Message sent successfully!");
          formRef.current.reset(); // Clear form
        },
        (error) => {
          console.error("Email error:", error);
          setStatusMessage("Failed to send message. Please try again.");
        }
      );
  };

  const containerStyle = {
    maxWidth: "1000px",
    width: "100%",
    margin: "50px auto",
    padding: "20px",
    textAlign: "center",
    boxSizing: "border-box",
  };

  const headingStyle = {
    fontSize: "2rem",
    marginBottom: "10px",
    marginTop: "50px",
  };

  const paragraphStyle = {
    color: "#666",
    marginBottom: "20px",
  };

  const contentStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "50px",
    alignItems: "flex-start",
    width: "100%",
  };

  const formStyle = {
    flex: "1",
    minWidth: "300px",
    maxWidth: "500px",
    textAlign: "left",
    width: "100%",
    boxSizing: "border-box",
  };

  const labelStyle = {
    fontWeight: "bold",
    marginTop: "10px",
    display: "block",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxSizing: "border-box",
  };

  const buttonStyle = {
    marginTop: "15px",
    padding: "12px",
    backgroundColor: "#bf1e2e",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    width: "100%",
    fontSize: "1rem",
  };

  const infoStyle = {
    flex: "1",
    minWidth: "250px",
    maxWidth: "400px",
    textAlign: "left",
    width: "100%",
    boxSizing: "border-box",
  };

  const infoHeadingStyle = {
    marginTop: "20px",
    color: "#333",
  };

  const infoTextStyle = {
    color: "#555",
  };

  const messageStyle = {
    marginTop: "10px",
    color: statusMessage.includes("success") ? "green" : "red",
  };

  return (
    <div id="contact-form" style={containerStyle}>
      <h2 style={headingStyle}>Contact Us</h2>
      <p style={paragraphStyle}>
        We’d love to hear from you! Reach out to us for any inquiries.
      </p>

      <div style={contentStyle}>
        {/* Left Column - Form */}
        <div style={formStyle}>
          <form ref={formRef} onSubmit={handleSubmit}>
            <label style={labelStyle}>Name</label>
            <input type="text" name="from_name" placeholder="Enter your name" required style={inputStyle} />

            <label style={labelStyle}>Phone</label>
<input type="tel" name="phone" placeholder="Enter your phone number" required style={inputStyle} />


            <label style={labelStyle}>Email</label>
            <input type="email" name="from_email" placeholder="Enter your email" required style={inputStyle} />

            <label style={labelStyle}>Message</label>
            <textarea rows="5" name="message" placeholder="Type your message" required style={inputStyle}></textarea>

            <button type="submit" style={buttonStyle}>Send Message</button>
            {statusMessage && <p style={messageStyle}>{statusMessage}</p>}
          </form>
        </div>

        {/* Right Column - Info */}
        <div style={infoStyle}>
          <h3 style={infoHeadingStyle}>Our Address</h3>
          <p style={infoTextStyle}>A- 86, Sipcot Housing Colony,Dharga, Hosur-635 126.</p>

          <h3 style={infoHeadingStyle}>Email</h3>
          <p style={infoTextStyle}>samson.sundaram@gmail.com</p>

          <h3 style={infoHeadingStyle}>Phone</h3>
          <p style={infoTextStyle}>94</p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
